import React from "react";

import Grid from 'shared-components/components/Grid';
import GridItem from 'shared-components/components/GridItem';
import Spinner from 'shared-components/components/Spinner';

import FilterArrow from 'shared-vectors/icons/FilterArrow';
import FilterArrowDsk from 'shared-vectors/icons/FilterArrowDsk';
import { Icon } from 'shared-vectors';

import { getMainLocalityText } from '@helpers/localityDisplay';

import StaticMapWithDrawings from '@components/common/StaticMapWithDrawings';

function Map({ tempLocationsQB, filters, isMobile, action}) {
  let mainLoc = tempLocationsQB?.uiLocations?.main
  if (mainLoc && mainLoc.name && (filters?.geocircle || filters?.nearby)) {
    mainLoc = JSON.parse(JSON.stringify(mainLoc));
    mainLoc.name = mainLoc.name
      .replace(' m da ', ' m da: ')
      .replace(' piedi da ', ' piedi da: ')
      .replace(' bici da ', ' bici da: ')
      .replace(' auto da ', ' auto da: ');
  }

  const text = getMainLocalityText({
    mainLoc,
    qExpansion: filters?.qExpansion || '0',
    hasChildrenLocality: false,
    showPreposition: !filters?.geopolygon,
    isRadiusSearch: filters?.geocircle,
    isQBLocalitySearch: true,
  });

  return (
    <Grid role="button" className="cnt-loc-srh__mb mb--m b--s" direction="column" onClick={action}>
      <GridItem behavior="fixed">
        <Grid>
          <GridItem className="pt--ms pr--ms pl--ms tp-s--m">
            {text}
          </GridItem>
          <GridItem behavior="fixed" push="left" aria-hidden="true" className="pt--ms pr--ms pl--ms">
            <Grid align="center" className="cnt-loc-srh">
              <Icon
                name={isMobile ? FilterArrow : FilterArrowDsk}
                width={isMobile ? '14px' : '16px'}
                height={isMobile ? '8px' : '16px'}
                className="rotate--270"
                fill={isMobile}
              />
            </Grid>
          </GridItem>
        </Grid>
      </GridItem>
      <GridItem className="p--ms">
        <div className="cnt-loc-srh__locmap-wrap b--s b-r--ds is-over--hid">
          <StaticMapWithDrawings
            filters={filters}
            containerClassName="cnt-loc-srh__locmap c-bg--bg is-rel"
            mapImgClassName="cnt-loc-srh__locmap__img"
            loaderComponent={(
              <Spinner
                className="cnt-loc-srh__locmap__spinner"
                size="l"
                color="secondary"
              />
            )}
          />
        </div>
      </GridItem>
    </Grid>    
  );
}
 export default Map;
